// Menu Service - AgentBheem ERP
import axios from 'axios'
import type { MenusResponse } from '@/types/menu'

// Create a separate axios instance for shared routes (no /api prefix)
const sharedApi = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
})

// Add auth interceptor
sharedApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

export const menuService = {
  /**
   * Fetch menus grouped by MenuGroup for sidebar rendering
   * Backend endpoint: GET /shared/menus?grouped=true
   */
  async getMenus(): Promise<MenusResponse> {
    const response = await sharedApi.get<MenusResponse>('/shared/menus', {
      params: { grouped: true },
    })
    return response.data
  },

  /**
   * Fetch all available menus (flat list for admin)
   */
  async getAllMenus(): Promise<MenusResponse> {
    const response = await sharedApi.get<MenusResponse>('/shared/menu/all')
    return response.data
  },
}
